import type { ReactNode } from 'react';
import { FormFieldContext } from './form-field-context';

type FormFieldProps = { name: string; children: ReactNode };

export function FormField({ name, children }: FormFieldProps) {
  return <FormFieldContext.Provider value={name}>{children}</FormFieldContext.Provider>;
}
